import TodoList from './todo-list';

export default TodoList;



// WEBPACK FOOTER //
// ./src/components/todo-list/index.js